import { FieldValues, useForm } from 'react-hook-form';
import {
  DEALER_FORM_DEFAULT_VALUES,
  SEARCH_FORM_DEFAULT_VALUES,
  SELECT_CUSTOMER_FORM_DEFAULT_VALUES
} from 'components/associated-dealers/constants/constants';
import { useMemo } from 'react';

export const useAssociatedDealerForms = () => {
  const selectCustomerForm = useForm<FieldValues>({
    defaultValues: SELECT_CUSTOMER_FORM_DEFAULT_VALUES
  });
  const dealerSearchForm = useForm<FieldValues>({
    defaultValues: DEALER_FORM_DEFAULT_VALUES
  });
  const searchResultsForm = useForm<FieldValues>({
    defaultValues: SEARCH_FORM_DEFAULT_VALUES
  });

  const forms = useMemo(() => {
    return {
      selectCustomerForm,
      dealerSearchForm,
      searchResultsForm
    };
  }, [selectCustomerForm, dealerSearchForm, searchResultsForm]);

  return forms;
};
